import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
export function ContactGate() {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  // Get existing inputs from localStorage
  const storedInputs = localStorage.getItem('calculatorInputs');
  const existingInputs = storedInputs ? JSON.parse(storedInputs) : {};
  const [inputs, setInputs] = useState({
    firstName: existingInputs.firstName || '',
    lastName: existingInputs.lastName || '',
    companyName: existingInputs.companyName || '',
    email: existingInputs.email || '',
    phone: existingInputs.phone || ''
  });
  const handleSubmit = async () => {
    setIsSubmitting(true);
    // Save contact info to localStorage
    const updatedInputs = {
      ...existingInputs,
      ...inputs
    };
    localStorage.setItem('calculatorInputs', JSON.stringify(updatedInputs));
    // Send data to webhook
    try {
      const webhookData = {
        firstName: inputs.firstName,
        lastName: inputs.lastName,
        companyName: inputs.companyName,
        email: inputs.email,
        phone: inputs.phone,
        revenuePerSale: existingInputs.ticket || '',
        grossProfitMarginPerSale: existingInputs.gpm || '',
        salesPerRookiesUnder90Days: existingInputs.salesFirst90Total || '',
        salesPerMonthOfVeterans: existingInputs.salesVetMonthly || '',
        installRate: existingInputs.pullthrough || ''
      };
      await fetch('https://services.leadconnectorhq.com/hooks/cMCCKDs5F12Q4UIyFTOq/webhook-trigger/61437d83-831c-4ec5-b4d1-46b4d952a56d', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(webhookData)
      });
    } catch (error) {
      console.error('Failed to send webhook:', error);
      // Continue to results page even if webhook fails
    }
    setIsSubmitting(false);
    navigate('/results');
  };
  const isFormValid = inputs.email && inputs.companyName && inputs.firstName && inputs.lastName && inputs.phone;
  return <div className="min-h-screen bg-gradient-to-br from-navy via-navy-light to-navy flex flex-col" data-id="element-674">
      <div className="flex-1 flex items-center justify-center px-4 py-6 md:py-8" data-id="element-675">
        <div className="max-w-2xl w-full" data-id="element-676">
          <div className="flex justify-center mb-8" data-id="element-677">
            <img src="https://cdn.magicpatterns.com/uploads/jrZpZA6KS7cefrnJNRcqNs/Copy_of_HIRE.png" alt="HIRE" className="h-8 md:h-10 cursor-pointer" onClick={() => navigate('/')} data-id="element-678" />
          </div>

          <div className="text-center mb-6 md:mb-8" data-id="element-679">
            <h2 className="text-2xl md:text-4xl font-bold text-white mb-3 md:mb-4" data-id="element-680">
              Where Should We Send Your Results?
            </h2>
            <p className="text-base md:text-lg text-blue-100" data-id="element-681">
              Get your personalized 12-month ROI projection
            </p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-lg border-2 border-white/20 p-4 md:p-6 mb-6" data-id="element-682">
            <div className="space-y-3 md:space-y-4" data-id="element-683">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4" data-id="element-684">
                <div data-id="element-685">
                  <label className="block text-xs md:text-sm font-semibold text-white mb-1.5 md:mb-2" data-id="element-686">
                    First Name
                  </label>
                  <input type="text" name="given-name" autoComplete="given-name" value={inputs.firstName} onChange={e => setInputs({
                  ...inputs,
                  firstName: e.target.value
                })} placeholder="John" className="w-full p-3 md:p-4 rounded-lg border-2 border-white/30 bg-white/5 text-white placeholder-blue-200 outline-none focus:border-amber transition-colors text-base md:text-lg backdrop-blur-sm" data-id="element-687" />
                </div>
                <div data-id="element-688">
                  <label className="block text-xs md:text-sm font-semibold text-white mb-1.5 md:mb-2" data-id="element-689">
                    Last Name
                  </label>
                  <input type="text" name="family-name" autoComplete="family-name" value={inputs.lastName} onChange={e => setInputs({
                  ...inputs,
                  lastName: e.target.value
                })} placeholder="Smith" className="w-full p-3 md:p-4 rounded-lg border-2 border-white/30 bg-white/5 text-white placeholder-blue-200 outline-none focus:border-amber transition-colors text-base md:text-lg backdrop-blur-sm" data-id="element-690" />
                </div>
              </div>
              <div data-id="element-691">
                <label className="block text-xs md:text-sm font-semibold text-white mb-1.5 md:mb-2" data-id="element-692">
                  Company Name
                </label>
                <input type="text" name="organization" autoComplete="organization" value={inputs.companyName} onChange={e => setInputs({
                ...inputs,
                companyName: e.target.value
              })} placeholder="Your Company" className="w-full p-3 md:p-4 rounded-lg border-2 border-white/30 bg-white/5 text-white placeholder-blue-200 outline-none focus:border-amber transition-colors text-base md:text-lg backdrop-blur-sm" data-id="element-693" />
              </div>
              <div data-id="element-694">
                <label className="block text-xs md:text-sm font-semibold text-white mb-1.5 md:mb-2" data-id="element-695">
                  Work Email
                </label>
                <input type="email" name="email" autoComplete="email" value={inputs.email} onChange={e => setInputs({
                ...inputs,
                email: e.target.value
              })} placeholder="you@company.com" className="w-full p-3 md:p-4 rounded-lg border-2 border-white/30 bg-white/5 text-white placeholder-blue-200 outline-none focus:border-amber transition-colors text-base md:text-lg backdrop-blur-sm" data-id="element-696" />
              </div>
              <div data-id="element-697">
                <label className="block text-xs md:text-sm font-semibold text-white mb-1.5 md:mb-2" data-id="element-698">
                  Phone Number
                </label>
                <input type="tel" name="tel" autoComplete="tel" value={inputs.phone} onChange={e => setInputs({
                ...inputs,
                phone: e.target.value
              })} placeholder="(555) 123-4567" className="w-full p-3 md:p-4 rounded-lg border-2 border-white/30 bg-white/5 text-white placeholder-blue-200 outline-none focus:border-amber transition-colors text-base md:text-lg backdrop-blur-sm" data-id="element-699" />
              </div>
            </div>
          </div>

          <button onClick={handleSubmit} disabled={!isFormValid || isSubmitting} className="w-full py-4 md:py-5 bg-amber hover:bg-amber-dark disabled:bg-amber/50 disabled:cursor-not-allowed text-navy font-bold text-lg md:text-xl rounded-lg transition-all shadow-xl hover:scale-105 active:scale-100 disabled:hover:scale-100 flex items-center justify-center gap-2" data-id="element-700">
            {isSubmitting ? <>
                <div className="w-5 h-5 border-2 border-navy border-t-transparent rounded-full animate-spin" data-id="element-701"></div>
                <span data-id="element-702">Processing...</span>
              </> : <>See My Full Results →</>}
          </button>

          {inputs.email && <p className="text-center text-blue-200 text-xs md:text-sm mt-3 md:mt-4" data-id="element-703">
              We'll email your detailed results to{' '}
              <span className="font-semibold text-white" data-id="element-704">{inputs.email}</span>
            </p>}
        </div>
      </div>

      <footer className="bg-navy/50 border-t-2 border-white/10" data-id="element-705">
        <div className="max-w-7xl mx-auto px-4 py-4 md:py-6" data-id="element-706">
          <div className="flex flex-col md:flex-row items-center justify-between gap-3" data-id="element-707">
            <img src="https://cdn.magicpatterns.com/uploads/jrZpZA6KS7cefrnJNRcqNs/Copy_of_HIRE.png" alt="HIRE" className="h-6 md:h-8" data-id="element-708" />
            <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 text-xs md:text-sm text-blue-200" data-id="element-709">
              <button onClick={() => navigate('/')} className="hover:text-white transition-colors" data-id="element-710">
                Home
              </button>
            </div>
          </div>
        </div>
      </footer>
    </div>;
}